export type BlockableLocationState = { blockable?: boolean };

/** Spread into a navigation's `state` so it passes the unsaved-changes Blocker. */
export const bypassBlocker = { blockable: false } as const satisfies BlockableLocationState;
